<app-sidebar></app-sidebar>
<div class="wrapper w-full min-w-full overflow-auto"> 
	<!-- style="z-index: 0;" -->
	<app-header></app-header>
	<div class="">
		<router-outlet></router-outlet>
		<!-- <div class="items-stretch gap-5 lg:gap-7 5">
				
			</div> -->
	</div>
	<!-- <app-footer></app-footer> -->
</div>

<!-- <div class="fixed bottom-4 right-4 z-50 flex flex-row-reverse gap-2">
	<app-chat-float></app-chat-float>
	<app-chat-float></app-chat-float>
</div> -->
<div class="fixed bottom-4 right-4 z-50 flex flex-row-reverse gap-2 items-end">
	<app-chat-float *ngFor="let pId of chatArray; trackBy: trackByChatId" [PatientID]="pId"
		(removeChat)="removeChatFromArray($event)"></app-chat-float>
</div>